var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseMenuWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2736_12880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2656 19.3125C18.9844 19.5938 18.4688 19.5938 18.1875 19.3125L12 13.0781L5.76562 19.3125C5.48438 19.5938 4.96875 19.5938 4.6875 19.3125C4.40625 19.0312 4.40625 18.5156 4.6875 18.2344L10.9219 12L4.6875 5.8125C4.40625 5.53125 4.40625 5.01562 4.6875 4.73438C4.96875 4.45312 5.48438 4.45312 5.76562 4.73438L12 10.9688L18.1875 4.73438C18.4688 4.45312 18.9844 4.45312 19.2656 4.73438C19.5469 5.01562 19.5469 5.53125 19.2656 5.8125L13.0312 12L19.2656 18.2344C19.5469 18.5156 19.5469 19.0312 19.2656 19.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2736_12880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseMenuWhite);
export default __webpack_public_path__ + "static/media/Icon_CloseMenu_White.a1b461704a85b898851bd5292dfe1332.svg";
export { ForwardRef as ReactComponent };